import { MetaMask } from "./metamask";
import { WalletProviderType } from "../services/enum/wallet-provider-type";
import type { Wallet } from "@/app/types/wallet";
import { WalletConnect } from "./walletConnect";
import { Coinbase } from "./coinbase";
import { Web3Authentication } from "./web3Auth";

export class WalletFactory {
  public getWallet(walletType: WalletProviderType): Wallet {
    switch (walletType) {
      case WalletProviderType.METAMASK:
        return new MetaMask();
      case WalletProviderType.COINBASE:
        return new Coinbase();
      case WalletProviderType.WEB3AUTH:
        return new Web3Authentication();
      case WalletProviderType.WALLET_CONNECT:
        return new WalletConnect();
      default:
        throw new Error("Unknown wallet type");
    }
  }
}
